import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import {word} from '../../word.js'
import ChangeMyData from "./ChangeMyData.js";

const OrgData = () => {
    const [show, setShow] = useState(false);
    const myData = useSelector((state) => state.manager.employee);

    return (
        <div className='data-section'>
            {show ? <div className='popup' onClick={() => setShow(false)}/> : null}
            {show ? <ChangeMyData close={() => setShow(false)} /> : null}
            <div className='container'>
                <p className='data-section my-data-section'>{word.personal_information}</p>
                {/* <div className="edit-delete-cont">
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Խմբագրել</div>
                        <span onClick={() => setShow(true)} className='icon-Compose'></span>
                    </div>
                </div> */}
                <Row className="my-data">
                    <Col xs={12} sm={6}>
                        <p className='data-line'>{word._name}</p>
                        <p className='data-line'>{word.phone}</p>
                        <p className='data-line'>{word.email}</p>
                    </Col>

                    <Col xs={12} sm={6}>
                        <p className='data-line'>{myData.user.first_name !== "undefined" ? <span>{myData.user.first_name} {myData.user.last_name}</span> : null} </p>
                        <p className='data-line'>{myData.phone}</p>
                        <p className='data-line'>{myData.user.email}</p>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default OrgData;
